import apiClient from '@/services/api/client';
import type { PaginatedResult } from '@/types';

export interface NotificationDto {
  id: number;
  recipientUserId: number;
  notificationType: number;
  notificationTypeName: string;
  title: string;
  message: string;
  contextJson?: string;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
}

export interface NotificationPreferenceDto {
  id: number;
  notificationType: number;
  notificationTypeName: string;
  label: string;
  emailEnabled: boolean;
}

// The Axios interceptor in interceptors.ts already unwraps response.data.data → response.data
// So all service functions just use response.data directly

export const getNotifications = async (page = 1, pageSize = 20): Promise<PaginatedResult<NotificationDto>> => {
  const response = await apiClient.get<PaginatedResult<NotificationDto>>('/notifications', {
    params: { page, pageSize },
  });
  return response.data;
};

export const getUnreadCount = async (): Promise<number> => {
  const response = await apiClient.get<{ count: number }>('/notifications/unread-count');
  return response.data.count;
};

export const markAsRead = async (id: number): Promise<void> => {
  await apiClient.patch(`/notifications/${id}/read`);
};

export const markAllAsRead = async (): Promise<void> => {
  await apiClient.patch('/notifications/read-all');
};

export const deleteNotification = async (id: number): Promise<void> => {
  await apiClient.delete(`/notifications/${id}`);
};

export const getPreferences = async (): Promise<NotificationPreferenceDto[]> => {
  const response = await apiClient.get<NotificationPreferenceDto[]>('/notification-preferences');
  return response.data;
};

export const updatePreference = async (type: number, emailEnabled: boolean): Promise<NotificationPreferenceDto> => {
  const response = await apiClient.put<NotificationPreferenceDto>(
    `/notification-preferences/${type}`,
    { emailEnabled },
  );
  return response.data;
};
